import { useQueryParams } from "@js/hooks";

import { useGetPublicInvitationDetailsQuery } from "../../api";
import { useStoredReferrer } from "../use-stored-referrer";

export const useSignUpInvitationData = ({ skip }: { skip?: boolean } = {}) => {
  const { invitation_key, job_id } = useQueryParams();
  const invitationKeyParam = invitation_key as string | null;
  const jobIdParam = job_id as string | null;
  const referrer = useStoredReferrer();
  const hasInvitationReference = referrer || invitationKeyParam;
  const skipInvitationFetch = skip || !hasInvitationReference;
  const {
    data: publicInvitationDetails,
    isFetching: fetchingPublicInvitationDetails,
  } = useGetPublicInvitationDetailsQuery(
    {
      referrer,
      invitation_key: invitationKeyParam ?? undefined,
      job_id: jobIdParam ?? undefined,
    },
    { skip: skipInvitationFetch },
  );

  return { publicInvitationDetails, fetchingPublicInvitationDetails };
};
